import { render, staticRenderFns } from "./ChallengeManagement.vue?vue&type=template&id=224aa836&scoped=true"
import script from "./ChallengeManagement.vue?vue&type=script&lang=js"
export * from "./ChallengeManagement.vue?vue&type=script&lang=js"
import style0 from "./ChallengeManagement.vue?vue&type=style&index=0&id=224aa836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224aa836",
  null
  
)

export default component.exports